<template lang="html">
    <div class="inputBar">
        <div class="search">
            <van-search v-model="msg" :shape="shape" :placeholder="placeholder" :background="background" @search="onSearch" @focus="onFocus" @input="onInput" @clear="onClear">
            </van-search>
            <div class="result" v-show="show">
                <slot></slot>
            </div>
        </div>
        <div class="overlay" v-show="show" @click="hideOverlay"></div>
    </div>
</template>
<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: '请输入搜索关键词'
        },
        background: {
            type: String,
            default: '#ffffff'
        },
        shape: {
            type: String,
            default: 'round'
        },
        text: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            show: false,
            msg: ''
        }
    },
    methods: {
        onFocus () {
            this.show = true
        },
        onSearch () {
            this.$emit('onSearch', this.msg)
        },
        onInput () {
            this.$emit('onInput', this.msg)
        },
        onClear () {
            this.$emit('onClear')
        },
        hideOverlay () {
            this.show = false
        }
    }
}
</script>
<style lang="stylus" scoped>
.search
    position relative
    z-index 77
    .result
        position absolute
        width 100%
        background #fff
.overlay
    position fixed
    z-index 66
    left 0
    right 0
    top 0
    bottom 0
    background rgba(0, 0, 0, 0.5)
</style>
